import React from "react";
import styled from "styled-components";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import "swiper/swiper.scss";
import HeaderSliderImg from "./HeaderSliderImg";

// Install Swiper modules
SwiperCore.use([Autoplay]);

const Wrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    height: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin: 0;
    /* padding: 0 16px; */

    .swiper-wrapper {
      align-items: center;
    }

    .swiper-slide {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`;

function HeaderSlider({ img }) {
  const [activeSlideHeader, setActiveSliderHeader] = React.useState(null);

  return (
    <Wrapper>
      <Swiper
        onInit={(swiper) => {
          setActiveSliderHeader(swiper.realIndex);
        }}
        slidesPerView={4.2}
        initialSlide={2}
        spaceBetween={2}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        allowTouchMove={true}
        onSlideChange={(swiper) => setActiveSliderHeader(swiper.realIndex)}
        centeredSlides={true}
        breakpoints={{
          // Mobile phones
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          // Tablets and up
          768: {
            slidesPerView: 4.2,
            spaceBetween: 2,
          },
        }}
      >
        {img.map((item, i) => (
          <SwiperSlide key={i + "98989"}>
            {({ isActive, isPrev, isNext }) => (
              <HeaderSliderImg
                img={item.src}
                id={i}
                activeSlide={activeSlideHeader}
                isActive={isActive}
                isPrev={isPrev}
                isNext={isNext}
                fetchpriority={i === 2 ? "high" : undefined}
              />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </Wrapper>
  );
}

export default HeaderSlider;
